export const itData = `
  <div class="paragraph">
    <div class="text-box">
      <div class="text">
      La empresa DANGHUAN EUROPE S.L. es la propietaria del sitio web www.Danghuan.eu.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. Objeto del Contrato</div>
    <div class="text-box">
      <div class="text">
        1.1 El objeto del contrato es la venta entre el Cliente y DANGHUAN EUROPE S.L. del/los dispositivo(s) indicados en el Formulario de Transferencia disponible en la página web www.Danghuan.eu, que forma parte integral de este contrato. Los dispositivos deben ser funcionales y coincidir con las características, condiciones y calidad indicadas en el Formulario de Transferencia relacionado.
      </div>
      <div class="text">
        1.2 La venta de los dispositivos puede realizarse en línea a través de la Plataforma Danghuan, en uno de los puntos de venta de DANGHUAN EUROPE S.L., o en establecimientos minoristas de diversos socios participantes en la iniciativa promovida por DANGHUAN EUROPE S.L.
      </div>
      <div class="text">
        1.3 El contrato se concluye con la aceptación del dispositivo por parte de DANGHUAN EUROPE S.L. y está sujeto a la verificación, según lo estipulado en el artículo 5.2, de la funcionalidad del dispositivo, tal como se indica en el Formulario de Transferencia adjunto. Si la inspección de la funcionalidad del dispositivo resulta negativa, el contrato será nulo y no vinculante.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. Procedimientos de Ejecución</div>
    <div class="text-box">
      <div class="text">
      2.1 Con el fin de ofrecer su dispositivo a la venta, el Cliente deberá completar el Formulario de Transferencia disponible en la página web www.Danghuan.eu, especificando la marca/tipo/condición del dispositivo según los parámetros indicados en el archivo PDF adjunto, y garantizando su plena funcionalidad. Una vez que el Cliente reciba la confirmación de interés de compra por parte de DANGHUAN EUROPE S.L., que incluye un valor aproximado basado en las condiciones estéticas y funcionales reportadas, si el Cliente está interesado en proceder con la venta, deberá enviar el dispositivo a DANGHUAN EUROPE S.L. para la inspección de funcionalidad.
      </div>
      <div class="text">
      2.2 La entrega del dispositivo se lleva a cabo de la siguiente manera:
      </div>
      <div class="text">
      • Para ofertas formalizadas a través de la Plataforma Danghuan: Por mensajería, con los gastos cubiertos por DANGHUAN EUROPE S.L.
      </div>
      <div class="text">
      • Para ofertas formalizadas en puntos de venta de DANGHUAN EUROPE S.L. y/o establecimientos asociados a la iniciativa: El Cliente deberá entregar directamente el dispositivo en el lugar donde se realizó la oferta.
      </div>
      <div class="text">
      2.3 La compra del dispositivo por parte de DANGHUAN EUROPE S.L. se efectúa, tras verificar su funcionalidad conforme a lo establecido en el punto 5.2, mediante la aceptación y firma gráfica del Formulario de Transferencia completado por el Cliente, el cual constituye una oferta de venta.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Entrega</div>
    <div class="text-box">
      <div class="text">
      3.1 Una vez que el dispositivo llegue al almacén de DANGHUAN EUROPE S.L., se someterá a una verificación de funcionalidad, según lo descrito en el artículo 5.2 a continuación.
      </div>
      <div class="text">
      3.2 Si la verificación de funcionalidad, según lo especificado en el artículo 5.2, arroja un resultado positivo, el dispositivo será retenido por DANGHUAN EUROPE S.L., que se convertirá en el único propietario del mismo.
      </div>
      <div class="text">
      3.3 Si, después de la verificación de funcionalidad mencionada en el artículo 5.2, el dispositivo se considera de un valor inferior al previamente comunicado, se someterá a una nueva evaluación, la cual será comunicada al cliente en un plazo de 48 horas.
      </div>
      <div class="text">
      La aceptación de la nueva evaluación por parte del cliente confirmará la venta, con las consecuencias descritas en el artículo 3.2. Si el cliente no acepta la nueva valoración, el dispositivo será devuelto en las condiciones especificadas en el artículo 3.4.
      </div>
      <div class="text">
      3.4 Si el dispositivo, después de la verificación de funcionalidad descrita en el artículo 5.2, se considera inadecuado, será devuelto al Cliente a cargo de DANGHUAN EUROPE S.L., eximiendo a DANGHUAN EUROPE S.L. de cualquier responsabilidad por daños o eventos imprevistos que puedan afectar al dispositivo desde el momento en que se entrega al mensajero hasta que sea recibido por el Cliente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Tarifas y Métodos de Pago</div>
    <div class="text-box">
      <div class="text">
      4.1 DANGHUAN EUROPE S.L. se compromete a pagar el precio de venta acordado, el cual se determina en función del modelo y estado del dispositivo vendido. El precio de venta será abonado por DANGHUAN EUROPE S.L. mediante transferencia bancaria al IBAN proporcionado por el Cliente.
      </div>
      <div class="text">
      4.2 El Cliente declara que el precio de venta ofrecido y recibido es adecuado, final y todo incluido, y acepta los métodos de pago descritos anteriormente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">5. Obligaciones y Garantías del Cliente</div>
    <div class="text-box">
      <div class="text">
       5.1 El Cliente declara y garantiza:
      </div>
      <div class="text">
      • Que es mayor de edad;
      </div>
      <div class="text">
      • Que los Dispositivos son de su exclusiva propiedad, que tienen una fuente legítima y están libres de cargas legales y comerciales;
      </div>
      <div class="text">
      • Que los Dispositivos corresponden a las características y calidades indicadas en el Formulario de Transferencia adjunto a este contrato y, en particular, que son funcionales y pueden realizar llamadas telefónicas.
      </div>
      <div class="text">
      5.2 El Cliente autoriza a DANGHUAN EUROPE S.L. a verificar la funcionalidad de los Dispositivos al recibirlos, específicamente con respecto a su capacidad para realizar llamadas telefónicas.
      </div>
      <div class="text">
      5.3 El Cliente está obligado a cancelar y/o terminar cualquier contrato y/o suscripción relacionada con el Dispositivo que es objeto de la oferta de venta. El Cliente también debe eliminar cualquier sistema de seguimiento y/o seguridad asociado con el Dispositivo.
      </div>
      <div class="text">
      5.4 El Cliente reconoce que, al entregar los Dispositivos, debe retirar la tarjeta SIM y cualquier tarjeta de memoria, y declara que ha eliminado cualquier dato personal presente en ellas, incluyendo las contraseñas de seguridad del dispositivo.
      </div>
      <div class="text">
      5.5 El Cliente autoriza a DANGHUAN EUROPE S.L. a eliminar y/o hacer ilegibles cualquier dato personal que aún pueda estar presente en los Dispositivos y a destruir la tarjeta SIM y/o cualquier tarjeta de memoria que no haya sido retirada de los Dispositivos.
      </div>
      <div class="text">
      5.6 El Cliente es responsable de la integridad, exactitud y veracidad de todos los datos comunicados a DANGHUAN EUROPE S.L. y reconoce estar al tanto de las sanciones penales previstas en los términos y condiciones locales, que establecen que realizar declaraciones falsas, formar y utilizar documentos falsos es punible según el código penal y las leyes especiales sobre la materia.
      </div>
      <div class="text">
      5.7 El Cliente garantiza que el Dispositivo no ha sido manipulado y que no existen defectos ocultos en el mismo.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">6. Responsabilidad</div>
    <div class="text-box">
      <div class="text">
      6.1 DANGHUAN EUROPE S.L. no asume ninguna responsabilidad frente al Cliente por daños y/o perjuicios que puedan surgir de la evaluación de la funcionalidad de los Dispositivos mencionados en la sección 5.2 anterior. El Cliente es consciente de que, tras la verificación de funcionalidad mencionada en la sección 5.2, DANGHUAN EUROPE S.L. tiene el derecho de rechazar la oferta de venta, incluso parcialmente. DANGHUAN EUROPE S.L. no podrá ser considerado responsable, en ningún caso, frente al Cliente por daños contractuales y/o extracontractuales, directos o indirectos, derivados de la no aceptación, incluso parcial, de la oferta de venta, o por el no retiro de la tarjeta SIM de los dispositivos o por el uso de la propia SIM.
      </div>
      <div class="text">
      6.2 DANGHUAN EUROPE S.L. no será responsable del pago de ninguna reclamación realizada por el operador telefónico del Cliente, ni antes ni después de la compra del Dispositivo por parte del Cliente. Además, el Cliente no podrá reclamar ningún daño derivado de la no recepción y/o envío de comunicaciones de cualquier tipo mientras el Dispositivo esté, incluso temporalmente, en posesión de DANGHUAN EUROPE S.L.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">7. Tratamiento de Datos Personales</div>
    <div class="text-box">
      <div class="text">
      7.1 DANGHUAN EUROPE S.L., de acuerdo con la legislación sobre protección de datos, asume el papel de "responsable del tratamiento" independiente, así como el Responsable del tratamiento de los datos personales adquiridos en cualquier capacidad en relación con la ejecución de este contrato de compraventa. En consecuencia, DANGHUAN EUROPE S.L. se compromete a cumplir con todas las leyes y regulaciones aplicables en relación con la protección y tratamiento de datos relacionados con la relación establecida por este contrato, comprometiéndose, en particular, a eliminar de forma segura todos los datos personales que puedan estar presentes en los Dispositivos.
      </div>
      <div class="text">
      7.2 El Cliente reconoce, de acuerdo con los términos y condiciones relacionados, que sus datos personales pueden estar sujetos a tratamiento, incluso con la asistencia de herramientas electrónicas, por parte de DANGHUAN EUROPE S.L. y del personal designado para este fin, con el objetivo de cumplir con las obligaciones derivadas de este contrato y los requisitos regulatorios relacionados, de acuerdo con los métodos y dentro de los límites indicados en dichos términos.
      </div>
      <div class="text">
      7.3 En relación con lo indicado en el aviso correspondiente a los términos y condiciones, el Cliente declara consentir la transferencia de sus datos personales por parte de DANGHUAN EUROPE S.L. a su sede, empresas del grupo y/o empresas de confianza, para los fines y dentro de los límites indicados en el mismo aviso.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">8. Disposiciones Finales</div>
    <div class="text-box">
      <div class="text">
      8.1 Este contrato se rige e interpreta de acuerdo con la legislación local.
      </div>
      <div class="text">
      8.2 Para cualquier disputa que surja entre las Partes con respecto a la existencia, validez, eficacia, interpretación, ejecución y/o terminación de este Contrato, la jurisdicción exclusiva será la del Tribunal local.
      </div>
      <div class="text">
      8.3 Las partes excluyen expresamente la aplicación de la Convención de las Naciones Unidas sobre Contratos de Compraventa Internacional de Mercaderías (CISG).
      </div>
      <div class="text">
      Aviso conforme al Decreto Legislativo local sobre la Protección de Datos Personales
      </div>
      <div class="text">
      De acuerdo con el Decreto Legislativo local (Código de Protección de Datos Personales), DANGHUAN EUROPE S.L., como Responsable del Tratamiento, proporciona la información relacionada con el posible tratamiento de datos personales adquiridos en relación con la ejecución de este contrato de compraventa.
      </div>
      <div class="text">
      Los datos personales de los clientes que firmen este contrato de compraventa pueden estar sujetos a tratamiento, incluso con la asistencia de herramientas electrónicas, por parte de DANGHUAN EUROPE S.L. y el personal designado para este fin, con el propósito de cumplir con las obligaciones derivadas de este contrato y los requisitos regulatorios correspondientes, conforme a los métodos y dentro de los límites indicados en los términos y condiciones mencionados.
      </div>
      <div class="text">
      El tratamiento de los datos personales se llevará a cabo de manera estrictamente relacionada con los fines mencionados anteriormente y, en cualquier caso, de una manera que garantice la seguridad, protección y confidencialidad de los datos.
      </div>
      <div class="text">
      Para llevar a cabo algunas actividades relacionadas con los fines del tratamiento de datos personales, tal como se especifica más arriba, DANGHUAN EUROPE S.L. podrá contratar a terceros pertenecientes a las siguientes categorías:
      </div>
      <div class="text">
      • Sujetos que prestan servicios bancarios o financieros;
      </div>
      <div class="text">
      • Sujetos que prestan servicios para la gestión del sistema informático y de información del programa de compra;
      </div>
      <div class="text">
      • Sujetos involucrados en la gestión de servicios de pago y redes telemáticas.
      </div>
      <div class="text">
      Los sujetos de estas categorías utilizarán los datos recibidos como responsables independientes del tratamiento, a menos que sean designados por DANGHUAN EUROPE S.L. como encargados del tratamiento por su experiencia específica.
      </div>
      <div class="text">
      El cliente tiene derecho, en cualquier momento, a conocer qué datos están siendo tratados y cómo se están utilizando, así como a solicitar actualizaciones, integraciones y correcciones, o a solicitar la eliminación, bloqueo y oposición al tratamiento si se lleva a cabo de manera ilegal, conforme al Decreto Legislativo local, escribiendo a DANGHUAN EUROPE S.L. en la sede registrada indicada anteriormente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">9. Pago</div>
    <div class="text-box">
      <div class="text">
      9.1 Precios y Condiciones de Pago
      </div>
      <div class="text">
      Cuando ofrezca vender productos de segunda mano, el pago se procesará inmediatamente después de la aceptación de la oferta, contraoferta o oferta revisada, ya sea por nuestra parte o por la suya. El pago puede realizarse a través de uno de los siguientes métodos:
      </div>
      <div class="text">
      • Transferencia a su cuenta IBAN
      </div>
      <div class="text">
      • Pago a una aplicación financiera de terceros
      </div>
      <div class="text">
      • Pago mediante vale
      </div>
      <div class="text">
      Si opta por una transferencia bancaria, cualquier riesgo de transferencia incorrecta debido a errores en los datos bancarios proporcionados será de su responsabilidad. Los pagos generalmente tardan hasta 7 días hábiles en reflejarse en su cuenta, dependiendo del banco y el país. Para transferencias internacionales, cualquier tarifa asociada será de su responsabilidad. Consulte con su banco para conocer los cargos específicos de la transferencia.
      </div>
      <div class="text">
      9.2  Información Incorrecta de Pago
      </div>
      <div class="text">
      Si proporciona detalles incorrectos de pago, no podremos procesar el pago. En estos casos, comuníquese con nuestro servicio de atención al cliente postventa para obtener asistencia en: <span class="email">support.payment@Danghuan.eu</span>
      </div>
    </div>
  </div>
`;
